import { UnknownAction } from '@reduxjs/toolkit'
import { createReducer } from '@reduxjs/toolkit/react'
import { AsyncData, DataStatus } from '@repo/ui/utils'
import { storeActions } from './actions'

export type SignUpState = {
  signedUp: AsyncData<boolean>
}

export const signUpInitialState: SignUpState = {
  signedUp: DataStatus.Uninitialized,
}

export const signUpReducer: ((
  state: SignUpState | undefined,
  action: UnknownAction,
) => SignUpState) & {
  getInitialState: () => SignUpState
} = createReducer(signUpInitialState, (builder) => {
  builder
    .addCase(storeActions.user.signUp.pending, (state) => {
      state.signedUp = DataStatus.Loading
    })
    .addCase(storeActions.user.signUp.rejected, (state) => {
      state.signedUp = DataStatus.Error
    })
    .addCase(storeActions.user.signUp.fulfilled, (state) => {
      state.signedUp = true
    })
})
